module.exports = __webpack_public_path__ + "img/plan_4.5141beb5.jpg";